/* ***** ----------------------------------------------- ***** **
** ***** Ajax Load JS
** ***** ----------------------------------------------- ***** */

/* global jQuery, Main, ga */
(function($){
	'use strict';

	Main.modules.ajaxLoad = function() {

		var $body = $('body'),
			$content = $('.l-content'),
			$header = $('.c-header'),
			$siteContainerOverlay = $('.l-site_container_overlay'),
			currentHost = window.location.host,
			currentPageTitle = document.title,
			errorMessage = '<h2 style="padding:3rem">There was an error with your request. Please try again.</h2>',
			modules = Main.modules,
			$headerCategorySort,
			currentHref,
			currentPagePath,
			newBodyClasses,
			newContent,
			newHeaderCategorySortContainer,
			newHighlightedItem,
			pageTitle,

			linkOnClick = function() {
				
				$body.on('click', 'a', function(e) {

					var $this = $(this),
						href = $this.attr('href');

					if (href.indexOf(currentHost) > 1
						&& !$this.hasClass('js-load_more')
						&& href.indexOf('wp-content') == -1
						&& href.indexOf('wp-admin') == -1
						&& $this.attr('target') != '_blank') {
						e.preventDefault();

						// If a slideout menu item was clicked, close menu and load page
						if ($this.hasClass('o-main_nav-menu_item')
							&& $this.closest('.o-main_nav--slideout_menu').length) {
							$siteContainerOverlay.click();
						}

						// If a main menu item with a post slideout was clicked, close slideout and load page
						if ($this.hasClass('o-main_nav-menu_item')
							&& $this.closest('.o-main_nav--header').length) {

							var $mainNavMenuItemLabel = $this.find('.o-main_nav-menu_item_label').text(),
								$headerPostSlideoutItemLabel = $('.c-header_post_slideout-item[data-main_menu_item="' + $mainNavMenuItemLabel + '"]');

							if($headerPostSlideoutItemLabel.length) {
								modules.header().headerPostSlideoutClose();
							}
						}

						// If a header post slideout item or see more link was clicked, close slideout and load page
						if ($this.closest('.o-post_preview--header_nav_slideout').length
							|| $this.closest('.c-header_post_slideout-see_more').length) {
							modules.header().headerPostSlideoutClose();
						}

						// Push new URL to address bar
						History.pushState({randomData: Math.random()}, '', href);
					}
				});

			},

			popState = function() {

				History.Adapter.bind(window, 'statechange', function() {

					var state = History.getState(),
						randomData = state.data.randomData,
						isInternal = state.internal;

					if (randomData || isInternal) {
						// Prevent page title from disappearing by setting the previous page title before 
						// setPageTitle updates the title
						document.title = currentPageTitle;
						currentHref = location.href;

						// Add loading overlay
						$content.addClass('l-content--is_loading');

						// Load new page
						loadPage(currentHref);
					}

				});

			},

			loadPage = function(url) {

				$.ajax({
					url: url,
					success: function(html) {
						
						// Parse the content of the loaded page
						newBodyClasses = html.match(/body class=\"(.*?)\"/)[1];
						newContent = $(html).find('.l-content').html();

						currentPagePath = window.location.pathname;

						// Replace the current list of classes with those used on the loaded page
						$body.attr('class', newBodyClasses);

						// Add loaded page content to current page
						$content.html(newContent);

						// Update elements on page to reflect loaded page
						setPageTitle(html);
						updateHeaderCategorySort(html);
						updateMenuHighlight(html);

						// Load relevant JS for loaded page
						loadPageJS();

						// If Google Analytics is loaded, manually fire page view
						if (typeof ga === 'function') {
							fireGoogleAnalytics(currentPagePath, currentPageTitle);
						}

						// Remove loading overlay
						$content.removeClass('l-content--is_loading');

						// Take user to the top of the page
						$(window).scrollTop(0);

					},
					error: function() {
						$content.html(errorMessage);
					}

				});

			},

			setPageTitle = function(html) {

				// Get page title from new page
				pageTitle = $(html).filter('title').text();

				// Set current page title in browser
				document.title = pageTitle;

				// Set current page title variable for when a new page is in the process of loading
				currentPageTitle = pageTitle;

			},

			updateHeaderCategorySort = function(html) {

				// Check if the current page has a header category sort container, if so, remove
				$headerCategorySort = $('.c-header_category_sort');

				if ($headerCategorySort.length){
					$headerCategorySort.remove();
				}

				// Check if new page has a header category sort, if so, add to page
				newHeaderCategorySortContainer = $(html).find('.c-header_category_sort');

				if (newHeaderCategorySortContainer.length) {
					$header.append(newHeaderCategorySortContainer);
				}

			},

			updateMenuHighlight = function(html) {

				// Get the title of the highlighted item from the new page
				newHighlightedItem = $(html).find('.o-main_nav-menu_item--current').attr('title');

				// Clear highlight from all menu items
				$('.o-main_nav-menu_item').removeClass('o-main_nav-menu_item--current');

				// Highlight the new item and remove the highlight from the previous
				$('.o-main_nav-menu_item[title="' + newHighlightedItem + '"]').addClass('o-main_nav-menu_item--current');

			},

			loadPageJS = function() {

				// Initialize these functions based on the page that is loaded

				if ($body.hasClass('home')) {

					modules.flexslider().homeFeaturedMainSlider();
					modules.flexslider().calculateHomeFeaturedMainSliderNavTop();
					modules.flexslider().homeFeaturedMusicSlider();
					modules.flexslider().homeFeaturedVideosSlider();
					modules.flexslider().featuredEventsSlider();

				} else if ($body.hasClass('category-news')) {

					modules.post().featuredMainNewsArticleSetHeight();
					modules.flexslider().featuredEventsSlider();
					modules.infiniteScroll().infiniteScrollNews();

				} else if ($body.hasClass('category-videos')
					|| $body.hasClass('category-music')) {

					modules.flexslider().trendingSlider();
					modules.infiniteScroll().infiniteScrollMedia();

				} else if($body.hasClass('category')
					|| $body.hasClass('search')
					|| $body.hasClass('author')) {

					modules.infiniteScroll().infiniteScrollArchive();

				} else if ($body.hasClass('post-type-archive-event')) {

					modules.infiniteScroll().infiniteScrollEvents();

				} else if ($body.hasClass('single')) {

					modules.post().responsiveVideoWrap();
					modules.audioPlayer().postAudioPlayerPreload();
					modules.audioPlayer().checkAndSyncAudioPlayers();

					if ($body.hasClass('single-post')) {
						modules.header().fixedMetadataRow();
						modules.post().playVideo();
						modules.post().reinitializeTaboola();
					}

				}

				// Initialize lazy load on all pages
				modules.lazyLoad().lazyLoad();

			},

			fireGoogleAnalytics = function(currentPagePath, currentPageTitle) {

				ga('set', {page: currentPagePath, title: currentPageTitle});
				ga('send', 'pageview');

			};

		return {
			init: function() {
				linkOnClick();
				popState();
			}
		}
		
	};

})(jQuery);